// the purpose of local preferences is to abstract local storage for flags/settings/preferences
import { Config, BUILD_TYPE } from 'utils/webappConfig';

const preferenceKeys = Object.freeze({
  suppressWindowError: 'suppressWindowError',
  suppressAssertPopups: 'suppressAssertPopups',
  disableBugsnag: 'disableBugsnag',
  ignoreBugsnagReport: 'ignoreBugsnagReport',
  persist: 'persist', // local copy of LD 'persist'
  persistOverride: 'persistOverride', // local override for LD 'persist'
  lastSession: 'lastSession',
  pollDataset: 'pollDataset',
  mobileWarningShown: 'mobileWarning',
  keepLoggedIn: 'keepLoggedIn',
  whyDidYouRender: 'whyDidYouRender',
  wdyrSettings: 'wdyrSettings',
  featureFlagsFreeze: 'featureFlagsFreeze',

  // ^^^ add your new preferences above
});

// why protection needed: https://stackoverflow.com/a/18878068
const corruptedString = "Sorry, it looks like your browser storage has been corrupted.\n" +
  "Please clear your storage by going to Tools -> Clear Recent History -> Cookies and set time range to 'Everything'.\n" +
  "This will remove the corrupted browser storage across all sites.";

function setItem(key, value) {
  if (value === undefined) {
    removeItem(key);
  } else {
    const jsonValue = JSON.stringify(value);
    try {
      localStorage?.setItem(key, jsonValue);
    } catch (e) {
      assert(false, corruptedString, key, value, e);
    }
  }
}

function getItem(key) {
  let value;
  let jsonValue;
  try {
    jsonValue = localStorage?.getItem(key);
  } catch (e) {
    assert(false, corruptedString, key, null, e);
  }
  try {
    value = JSON.parse(jsonValue);
  } catch (e) {
    assert(false,'Invalid local prefs data %s = %s\n', key, jsonValue, e);
  }

  return value;
}

function removeItem(key) {
  try {
    localStorage?.removeItem(key);
  } catch (e) {
    assert(false, corruptedString, key, null, e);
  }
}

export function getSuppressWindowError() {
  let value;
  value = true;
/////////////////////////////////////////////////////////////////////////////////////////////////////////////////
//////////////////////////////////////////////////////
//////////////////////////////////////////////
//////////////////
///
///////////
  return value;
}

export function setSuppressWindowError(value) {
  setItem(preferenceKeys.suppressWindowError, value);
}

export function getSuppressAssertPopups() {
  let value;
  value = false;
/////////////////////////////////////////////////////////////////////////////////////////////////////////////////
///////////////////////////////////////////////////////
//////////////////////////////////////////////
//////////////////
///
///////////
  return value;
}

export function setSuppressAssertPopups(value) {
  setItem(preferenceKeys.suppressAssertPopups, value);
}

export function getDisableBugsnag() {
  let value;
  value = false;
/////////////////////////////////////////////////////////////////////////////////////////////////////////////////
/////////////////////////////////////////////////
//////////////////////////////////////////////
//////////////////
///
///////////
  return value;
}

export function setDisableBugsnag(value) {
  setItem(preferenceKeys.disableBugsnag, value);
}

export function getIgnoreBugsnagReport() {
  let value;
  value = false;
/////////////////////////////////////////////////////////////////////////////////////////////////////////////////
//////////////////////////////////////////////////////
//////////////////////////////////////////////
///////////////////////////////////////////////////////////////////////////////////////
///
///////////
  return value;
}

export function setIgnoreBugsnagReport(value) {
  setItem(preferenceKeys.ignoreBugsnagReport, value);
}

export const getPersist = () => {
  let value;
  value = getItem(preferenceKeys.persist) ?? false;
///////////////////////////////////////////////
////////////////////////////////////////
///////////
  return value;
};
export const setPersist = (value) => setItem(preferenceKeys.persist, value);


export const setPersistOverride = (value) => setItem(preferenceKeys.persistOverride, value);
export const getPersistOverride = () => getItem(preferenceKeys.persistOverride);

export const setFeatureFlagsFreeze = (value) => setItem(preferenceKeys.featureFlagsFreeze, value);
export const getFeatureFlagsFreeze = () => {
  let featureFlagsFreeze = false;
///////////////////////////////////////////////
//////////////////////////////////////////////////////////////////
///////////
  return featureFlagsFreeze;
}

export const setWhyDidYouRender = (value) => setItem(preferenceKeys.whyDidYouRender, value);
export const getWhyDidYouRender = () => {
  let whyDidYouRender = false;
///////////////////////////////////////////////
////////////////////////////////////////////////////////////
///////////
  return whyDidYouRender;
}

export const setWDYRSettings = (value) => setItem(preferenceKeys.wdyrSettings, value);
export const getWDYRSettings = () => ({
  trackAllPureComponents: true,
  trackHooks: true,
  logOnDifferentValues: false,
  logOwnerReasons: true,
  onlyLogs: false,
  collapseGroups: true,
  virtualIncludeAll: false,
  ...getItem(preferenceKeys.wdyrSettings),
});

export function getLastSession() {
  let value;
  value = {};
/////////////////////////////////////////////////////////////////////////////////////////////////////////////////
//////////////////////////////////////////////
//////////////////////////////////////////////
///////////////
///
///////////
  return value;
}

export function setLastSession(value) {
  setItem(preferenceKeys.lastSession, value);
}

export function removeLastSession() {
  removeItem(preferenceKeys.lastSession);
}

export function getPollDataset() {
  return getItem(preferenceKeys.pollDataset);
}

export function setPollDataset(value) {
  setItem(preferenceKeys.pollDataset, value);
}

export function removePollDataset() {
  removeItem(preferenceKeys.pollDataset);
}

export function getMobileWarningShown() {
  return getItem(preferenceKeys.mobileWarningShown);
}
export function setMobileWarningShown(value) {
  setItem(preferenceKeys.mobileWarningShown, value);
}

export const getKeepLoggedIn = () => getItem(preferenceKeys.keepLoggedIn);
export const setKeepLoggedIn = (value) => setItem(preferenceKeys.keepLoggedIn, value);


